import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@material-ui/core";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import debounce from "lodash.debounce";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import SimpleBackdrop from "utils/general";
import { CommonConfig } from "CommonConfig";
import { Tabs, Tab } from "@mui/material";

import moment from "moment";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Calendar } from "primereact/calendar";
import { ToggleButton } from "primereact/togglebutton";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

const Outward = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [outwardList, setOutwardList] = useState([]);
  const [outwardId, setOutwardId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [warehouseList, setWarehouseList] = useState(false);
  const [clientList, setClientList] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterData, setFilterData] = useState({
    DateRange: [],
    Input1: true, // And
    FromWarehouse: [],
    Input2: true, //And
    Client: [],
    OutwardType: "Sell",
    ToWarehouse: [],
  });

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      fetchOutwardList(data);
      GetClientList(data);
      GetWarehouseMaster(data);
      setIsInitialLoad(false);
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    debouncedSearch(userId, search);
  }, [search]);

  useEffect(() => {
    if (!isInitialLoad) {
      fetchOutwardList(userId);
    }
  }, [tabIndex]);

  const debouncedSearch = useCallback(
    debounce((userId, keyword) => {
      fetchOutwardList(userId, {}, keyword);
    }, 400),
    []
  );

  const GetClientList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Customer",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setClientList(filterArry);
        }
      })
      .catch(() => {});
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setWarehouseList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const fetchOutwardList = async (userId, event = {}, query = "") => {
    setLoading(true);
    const params = {
      UserId: userId,
      page: event.first ? event.first / rowsPerPage : 0,
      limit: event.rows || rowsPerPage,
      Query: query || "",
    };

    try {
      const response = await api.post(APIConstant.path.GetOutward, params);
      if (response.Success === 1) {
        setOutwardList(response.Data);
        setTotalRecords(response.TotalRecords);
        setFirst(event.first || 0);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const deleteOutward = async (e) => {
    try {
      let params = {
        OutwardId: outwardId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeleteOutward, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setOutwardId("");
            setShowDeleteModal(false);
            await fetchOutwardList(userId, 0);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const generatePdf = async (e) => {
    try {
      let params = {
        UserId: userId,
        FilterData: {
          ...filterData,
          Input1: !!filterData.Input1 ? "And" : "Or",
          Input2: !!filterData.Input2 ? "And" : "Or",
        },
      };
      await api
        .post(APIConstant.path.GenerateOutwardPdf, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setShowFilterModal(false);
          } else {
            cogoToast.error(res.Message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Add") {
      props.history.push("/admin/add-outward");
    } else if (type === "View") {
      props.history.push({
        pathname: "/admin/add-outward",
        state: {
          OutwardId: data?._id,
          OutwardType: data?.OutwardType,
          Type: "View",
        },
      });
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-outward",
        state: {
          OutwardId: data?._id,
          OutwardType: data?.OutwardType,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      setShowDeleteModal(true);
      setOutwardId(data._id);
    }
  };

  const actionTemplate = (rowData) => (
    <div className="icon-only-btn">
      {userPageAccess?.includes("Edit Outward") && (
        <i
          className="icon-editImage"
          onClick={() => handleOpen(rowData, "Edit")}
        ></i>
      )}
      {userPageAccess?.includes("View Outward") && (
        <i
          className="icon-view"
          onClick={() => handleOpen(rowData, "View")}
        ></i>
      )}
      {userPageAccess?.includes("Delete Outward") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    fetchOutwardList(userId, e, search);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-arrow-up-left"></i>
          <h2>Outward</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>
          <div
            className="e-add-btn"
            onClick={(e) => {
              setShowFilterModal(true);
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>
          {userPageAccess?.includes("Add Outward") ? (
            <div>
              <div className="e-add-btn" onClick={(e) => handleOpen(e, "Add")}>
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      {/* <Tabs
        value={tabIndex}
        onChange={(e, newValue) => setTabIndex(newValue)}
        aria-label="Outward Type"
      >
        <Tab label="Sell" />
        <Tab label="Production" />
        <Tab label="Transfer" />
      </Tabs> */}
      {loading ? <SimpleBackdrop /> : null}
      <DataTable
        className="main-table table-td e-company-table"
        value={outwardList}
        paginator
        rows={rowsPerPage}
        totalRecords={totalRecords}
        lazy
        onPage={onPageChange}
        first={first}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollable={true}
        scrollWidth="auto"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
        <Column
          field="OutwardDate"
          header="Date"
          body={(rowData) => moment(rowData.OutwardDate).format("DD/MM/YYYY")}
        />
        <Column field="OrderNo" header="Order No" />
        <Column field="InvoiceNo" header="Invoice No" />
        <Column
          field="ItemName"
          header="Raw Material/Item"
          body={(rowData) =>
            rowData?.ItemList?.map((item) => item.ItemName).join(", ")
          }
        />
        <Column field="ClientName" header="Client Name" />
        <Column field="GSTIN" header="GSTIN" />
        <Column
          field="TotalAmountExcludingGST"
          header="Total Amt (Excl. GST)"
        />
        <Column
          field="TotalAmountIncludingGST"
          header="Total Amt (Incl. GST)"
        />
        <Column body={actionTemplate} header="Actions" />
      </DataTable>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setOutwardId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Outward</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setOutwardId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setOutwardId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteOutward(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showFilterModal}
        onClose={() => {
          setShowFilterModal(false);
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Apply Filters</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowFilterModal(false);
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem md={4}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">Date range</label>
                  <Calendar
                    // ref={calendarRef}
                    className="wb-filter-dt"
                    placeholder="Start Date - End Date"
                    value={filterData.DateRange}
                    onChange={(e) => {
                      setFilterData((prevState) => ({
                        ...prevState,
                        DateRange: e.value,
                      }));
                    }}
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={2}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select"></label>
                  <div className="pill-toggle p-mt-3">
                    <ToggleButton
                      onLabel="And"
                      offLabel="Or"
                      checked={filterData.Input1}
                      onChange={(e) => {
                        setFilterData((prevState) => ({
                          ...prevState,
                          Input1: e.value,
                        }));
                      }}
                      // className={!filterData.Input1 ? "active" : ""}
                    />
                  </div>
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={4}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">From Warehouse</label>
                  <MultiSelect
                    value={filterData.FromWarehouse}
                    onChange={(e) =>
                      setFilterData((prevState) => ({
                        ...prevState,
                        FromWarehouse: e?.value,
                      }))
                    }
                    options={warehouseList}
                    optionLabel="label"
                    placeholder="Godown"
                    className="w-full md:w-20rem"
                  />
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={2}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select"></label>
                  <div className="pill-toggle p-mt-3">
                    <ToggleButton
                      onLabel="And"
                      offLabel="Or"
                      checked={filterData.Input2}
                      onChange={(e) => {
                        setFilterData((prevState) => ({
                          ...prevState,
                          Input2: e.value,
                        }));
                      }}
                      // className={!filterData.Input1 ? "active" : ""}
                    />
                  </div>
                </FormControl>
              </div>
            </GridItem>
            <GridItem md={4}>
              <div className="input-control select">
                <FormControl fullWidth>
                  <label htmlFor="simple-select">Select Outward Type</label>
                  <Dropdown
                    filter
                    options={[
                      { label: "Sell", value: "Sell" },
                      { label: "Transfer", value: "Transfer" },
                    ]}
                    value={filterData.OutwardType}
                    onChange={(e) =>
                      setFilterData((prevState) => ({
                        ...prevState,
                        OutwardType: e.target?.value,
                      }))
                    }
                    placeholder="Order No"
                    className="p-w-100"
                  />
                </FormControl>
              </div>
            </GridItem>
            {filterData.OutwardType === "Transfer" ? (
              <GridItem md={6}>
                <div className="input-control select">
                  <FormControl fullWidth>
                    <label htmlFor="simple-select">To Warehouse</label>
                    <MultiSelect
                      value={filterData.ToWarehouse}
                      onChange={(e) =>
                        setFilterData((prevState) => ({
                          ...prevState,
                          ToWarehouse: e?.value,
                        }))
                      }
                      options={warehouseList}
                      optionLabel="label"
                      placeholder="Warehouse"
                      className="w-full p-w-100"
                    />
                  </FormControl>
                </div>
              </GridItem>
            ) : (
              <GridItem md={6}>
                <div className="input-control select">
                  <FormControl fullWidth>
                    <label htmlFor="simple-select">Client</label>
                    <MultiSelect
                      value={filterData.Client}
                      onChange={(e) =>
                        setFilterData((prevState) => ({
                          ...prevState,
                          Client: e?.value,
                        }))
                      }
                      options={clientList}
                      optionLabel="label"
                      placeholder="Client"
                      className="w-full md:w-20rem"
                    />
                  </FormControl>
                </div>
              </GridItem>
            )}
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowFilterModal(false);
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => generatePdf()}
            type="submit"
          >
            Generate Pdf
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Outward;
